module.exports = __webpack_public_path__ + "static/american-heiress-3cf20e91fc826651f68b8c0d0fe743bb.jpg";